export default __webpack_public_path__ + "static/media/disability.89459c22.svg";